import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=da84e58a"
import script from "./LayoutLogin.vue?vue&type=script&lang=js"
export * from "./LayoutLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports